import i18n from '@/i18n/i18n';

export const transactionOptions: { [key: string]: string } = {
  Num: i18n.t('HomePage.PerformanceOverviewWidget.TransactionOptions.Num', {
    defaultValue: 'Total Amount of Transactions',
  }),
  Vol: i18n.t('HomePage.PerformanceOverviewWidget.TransactionOptions.Vol', {
    defaultValue: 'Volume of Transactions',
  }),
};
